import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import AEssenciaAbHft from "./sections/AEssenciaAbHft";
import ImpactInNumbers from "./sections/ImpactInNumbers";
import KgViagensRodape from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <AEssenciaAbHft />
      <ImpactInNumbers />
      <KgViagensRodape />
    </div>;
}